import React from "react";
import "./HamburgerMenu.css";
import { MdArrowForwardIos } from "react-icons/md";
import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import { version } from "../../version"

export default function HamburgerMenu(props) {
  const hideHamburgerMenu = () => {
    props.onHide();
  };

  return (
    <div
      className="hamburgerMenu gymBg bgContainer"
      style={props.showHamburgerMenu ? { left: "0" } : { left: "-100vw" }}
    >
      <div
        className="hamburgerOverlay"
        style={
          props.showHamburgerMenu ? { display: "block" } : { display: "none" }
        }
        onClick={hideHamburgerMenu}
      ></div>
      <div className="hamburgerWrapper blurOverlay">
        <div className="hambergerMenuWrapperTop">
          <div className="hambergerMenuTitle centeredFlex">
          <h2 className="verticalBorder">REDROSE</h2>
          </div>
          <div className="hamburgerList centeredFlex">
            <Link
              to="/editProfile"
              className="hamburgerListItem horizontalBorder link centeredFlex"
            >
              <span>ویرایش نمایه</span>
              <MdArrowForwardIos className="hamburgerArrow" />
            </Link>
            <Link
              to="/setting"
              className="hamburgerListItem horizontalBorder link centeredFlex"
            >
              <span>تنظیمات</span>
              <MdArrowForwardIos className="hamburgerArrow" />
            </Link>
            <Link
              to="/guide"
              className="hamburgerListItem horizontalBorder link centeredFlex"
            >
              <span> REDROSE درباره برنامه</span>
              <MdArrowForwardIos className="hamburgerArrow" />
            </Link>
            <Link
              to="/coins"
              className="hamburgerListItem horizontalBorder link centeredFlex"
            >
              <div className="giftCode">
                <p>دعوت با کد هدیه</p>
                <span>با دعوت از دوستان خود سکه دریافت کنید</span>
              </div>
              <MdArrowForwardIos className="hamburgerArrow" />
            </Link>
            <a
              href="https://www.instagram.com/redrose.workout"
              className="hamburgerListItem horizontalBorder link centeredFlex"
            >
              <div className="hamburgerInstagram centeredFlex">
                <FaInstagram className="hamburgerInstagramIcon" />
                <p>REDROSE Instagram</p>
              </div>
            </a>
          </div>
        </div>
        <div className="hamburgerVersionWrapper centeredFlex">
          <img src="/images/grayLogo.svg" alt="logo" className="grayLogo" />
          <div className="hamburgerVersion">
            <p>REDROSE APP</p>
            <span>نسخه {version}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
